import { useEffect } from 'react';

const useBackInterceptor = (pathToReplace: string): void => {
  useEffect(() => {
    const handleBackButton = (e: PopStateEvent): void => {
      e.preventDefault();
      window.history.replaceState(null, '', pathToReplace);
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [pathToReplace]);
};

export default useBackInterceptor;
